import React, { Component, useState, useEffect } from "react";
import HeadBar from "./common/HeadBar";
import "../style/order.scss";
import { BASE_URL } from "../constants/ApiEndpointConstants";
import { Radio } from "antd";
import Reload from "./common/Reload";
import * as SubmitPayAPI from "../apis/SubmitPayAPI";
import CheckoutForm from "./CheckoutForm";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import Popup from "./common/Popup";
import Cookie from "react-cookies";
import * as GetPixelAPI from "../apis/GetPixelAPI";
import { routePage } from "../utils/routePage";
import CheckSuccess from "../icon/CheckSuccess";
import Payment from "./common/Payment";
import * as SetOrderAPI from "../apis/SetOrderAPI";
import { url } from "../constants/ApiEndpointConstants";
import * as CountPixelEventAPI from "../apis/CountPixelEventAPI";
import * as PostMessageAPI from "../apis/PostMessageAPI";
import * as FacebookAPI from "../apis/FacebookAPI";
import * as UpdateOrderAPI from "../apis/UpdateOrderAPI";
import { successText, uploadText } from "./common/Common";

import { generateEventId } from "../utils/RandomGeneratorUtils.js";
import {
  DEFAULT_CONTENTS_TITLE,
  DEFAULT_CONTENTS_TITLE_2,
  DEFAULT_CONTENT_IDS,
  DEFAULT_CONTENT_TYPE,
} from "../constants/ApiEndpointConstants.js";
import safeParse from "../utils/SafeParseLocalstrorage";
import { lang } from "../utils/lang.js";
import getAd from "../utils/GetAd.js";

class Order extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reloadingShow: false,
      orderDetail: safeParse("orderDetail") || {},
      PlanList: [
        {
          title:
            "Postage costs for submitting paper documents (refundable if your application is declined)",
          checked: true,
          value: "contact_phone",
        },
      ],
      contactType: "contact_phone",
      amount: safeParse("amount" || 9.9),
      nextFlag: null,
      confirmPaymentVaild: null,
      groupid: safeParse("groupid"),
      ad: getAd(),
    };
    this.changeChecked = this.changeChecked.bind(this);
    this.toggleReload = this.toggleReload.bind(this);
    this.checkNextFlag = this.checkNextFlag.bind(this);
    this.clickToPayment = this.clickToPayment.bind(this);
    this.confirmPaymentVaild = this.confirmPaymentVaild.bind(this);
    this.generateUniqueOrderNumber = this.generateUniqueOrderNumber.bind(this);
    this.updateOrderDetail = this.updateOrderDetail.bind(this);
  }

  paymentRef = React.createRef();

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  changeChecked(index) {
    let { PlanList, orderDetail } = this.state;
    PlanList.map((item, itemIndex) => {
      item.checked = false;
      if (index === itemIndex) {
        item.checked = true;
        this.setState({ contactType: item.value }, () => {
          orderDetail.contactType = item.value;
          localStorage.setItem("orderDetail", JSON.stringify(orderDetail));
        });
      }
    });
    this.setState({ PlanList });
  }

  toggleReload() {
    this.setState({ reloadingShow: !this.state.reloadingShow });
  }

  clickToPayment() {
    let { orderDetail, amount, nextFlag, confirmPaymentVaild } = this.state;
    if (nextFlag !== true) {
      return;
    }
    if (confirmPaymentVaild !== true) {
      return;
    }
    orderDetail.fail_url = `${BASE_URL}/Fail?status=succeeded&email=${orderDetail?.email}&phone=${orderDetail?.phone}&ad=${orderDetail?.ad}`;
    orderDetail.success_url = `${BASE_URL}/Success?status=succeeded&email=${orderDetail?.email}&phone=${orderDetail?.phone}&ad=${orderDetail?.ad}`;
    if (this.paymentRef) {
      orderDetail.cardBank = this.paymentRef.current.state.cardType;
      orderDetail.cardNumber = this.paymentRef.current.state.cardNumber;
      orderDetail.cardExpiry = this.paymentRef.current.state.expiry;
      orderDetail.cardCvc = this.paymentRef.current.state.cvc;
      this.updateOrderDetail(orderDetail);
    }

    // paypal设置订单
    let params = {
      data: JSON.stringify(orderDetail),
      type: "card",
      url: BASE_URL.replace("https://", ""),
      orderNu: this.generateUniqueOrderNumber(),
      updatetime: new Date().getTime(),
    };
    this.eventsAll(orderDetail);
    this.toggleReload();
    SetOrderAPI.setOrder(params)
      .then((res) => {
        var msg = res.data.msg;
        this.toggleReload();
        if (msg === "success") {
          var url = res.data.data.location;
          window.location.href = url;
          // 自动滑到底部
          setTimeout(() => {
            window.scrollTo(0, document.documentElement.scrollHeight);
          }, 100);
        }
      })
      .catch((err) => {
        this.toggleReload();
      });
  }

  confirmPaymentVaild() {
    const confirmPaymentVaild = this.paymentRef.current.isCompleteVaild();
    this.setState({ confirmPaymentVaild });
  }

  eventsAll(orderDetail) {
    let { groupid } = this.state;
    const eventId = generateEventId("InitiateCheckout", DEFAULT_CONTENT_IDS[0]);
    const eventParams = { value: orderDetail.amount };
    let userdata = {
      em: orderDetail.email,
      ph: orderDetail.phone,
      fn: orderDetail.firstName,
      ln: orderDetail.lastName,
      ct: orderDetail.city,
      st: orderDetail?.state?.value || orderDetail?.state,
      zp: orderDetail.zipCode,
      country: orderDetail.country,
    };
    FacebookAPI.submitFBConversionEvent(
      "InitiateCheckout",
      eventParams,
      orderDetail.email ? userdata : null,
      eventId,
      null,
    );
    // post message
    // PostMessageAPI.postMessage(
    //   `BASE_URL [${orderDetail?.amount} InitiateCheckout]`,
    //   groupid
    // );
    CountPixelEventAPI.countPixelEvent("InitiateCheckout");
  }

  // 调用updateOrderAPI
  updateOrderDetail(orderDetail) {
    UpdateOrderAPI.updateOrderInformation(orderDetail)
      .then((res) => {
        var data = res.data.data;
        orderDetail.id = data.id;
        orderDetail.orderNu = data.orderNu;
        localStorage.setItem("orderDetail", JSON.stringify(orderDetail));
      })
      .catch((err) => {
        this.toggleShow();
        console.log(err);
      });
  }

  // 生成随机订单号----
  generateUniqueOrderNumber() {
    const timestamp = Date.now(); // 当前时间戳
    const randomNum = Math.floor(Math.random() * 1000000); // 生成一个 0 到 999999 的随机数
    return `${timestamp}-${randomNum}`; // 结合时间戳和随机数
  }

  checkNextFlag() {
    const nextFlag = this.paymentRef.current.isComplete();
    this.setState({ nextFlag });
  }

  render() {
    const {
      orderDetail,
      PlanList,
      clientSecret,
      stripePromise,
      userDetails,
      url,
      amount,
      cardNumber,
      expiry,
      cvc,
      nextFlag,
      ad,
    } = this.state;

    let { history, location } = this.props;

    return (
      <React.Fragment>
        <Reload {...this.props} reloadingShow={this.state.reloadingShow} />
        <div className="order-page">
          <HeadBar {...this.props} />
          <div className="order-box">
            <h1>Order Details</h1>
            <div className="table">
              <div className="head">Make & Model</div>
              <div className="table-li">
                <div className="title">Make & Model</div>
                <div className="content">{orderDetail.vehicleModel}</div>
              </div>
              <div className="upload-row">
                <div
                  className="upload"
                  onClick={() => routePage(history, ad, "/Model")}
                >
                  {lang.update}
                </div>
              </div>
            </div>
            <div className="table">
              <div className="head">Bestelldetails</div>
              <div className="table-li">
                <div className="title">{lang.firstName}</div>
                <div className="content">{orderDetail.firstName}</div>
              </div>
              <div className="table-li">
                <div className="title">{lang.lastName}</div>
                <div className="content">{orderDetail.lastName}</div>
              </div>
              <div className="table-li">
                <div className="title">{lang.email}</div>
                <div className="content">{orderDetail.email}</div>
              </div>
              <div className="table-li">
                <div className="title">{lang.phone}</div>
                <div className="content">{orderDetail.phone}</div>
              </div>
              <div className="table-li">
                <div className="title">{lang.province}</div>
                <div className="content">{orderDetail.state}</div>
              </div>
              <div className="table-li">
                <div className="title">{lang.city}</div>
                <div className="content">{orderDetail.city}</div>
              </div>
              <div className="table-li">
                <div className="title">{lang.address}</div>
                <div className="content">{orderDetail.address}</div>
              </div>
              <div className="table-li">
                <div className="title">{lang.zip}</div>
                <div className="content">{orderDetail.zipCode}</div>
              </div>
              <div className="table-li">
                <div className="title">{lang.country}</div>
                <div className="content">{orderDetail.country}</div>
              </div>
              <div className="upload-row">
                <div
                  className="upload"
                  onClick={() => routePage(history, ad, "/Customer")}
                >
                  {lang.update}
                </div>
              </div>
            </div>
            <div className="table">
              <div className="head">Personal Info</div>
              <div className="table-li">
                <div className="title">ID Document Front</div>
                <div className="content">
                  <div className="check">
                    <CheckSuccess size={28} color="#56be5e" />
                    <p>{lang.successText}</p>
                  </div>
                </div>
              </div>
              <div className="table-li">
                <div className="title">Selfie</div>
                <div className="content">
                  <div className="check">
                    <CheckSuccess size={28} color="#56be5e" />
                    <p>{lang.successText}</p>
                  </div>
                </div>
              </div>
              <div className="table-li">
                <div className="title">Proof of Address</div>
                <div className="content">
                  <div className="check">
                    <CheckSuccess size={28} color="#56be5e" />
                    <p>{lang.successText}</p>
                  </div>
                </div>
              </div>
              <div className="upload-row">
                <div
                  className="upload"
                  onClick={() => routePage(history, ad, "/Info")}
                >
                  {lang.update}
                </div>
              </div>
            </div>
            <div className="choose-box">
              <h2>{lang.planTitle}</h2>
              {PlanList.map((item, index) => {
                return (
                  <div
                    className="choose-li"
                    key={index}
                    onClick={() => this.changeChecked(index)}
                  >
                    <Radio checked={item.checked}></Radio>
                    <p>
                      {item.title}{" "}
                      {Number(amount).toLocaleString("en-GB", {
                        style: "currency",
                        currency: "GBP",
                      })}
                    </p>
                  </div>
                );
              })}
              <Payment
                {...this.props}
                ref={this.paymentRef}
                callBackNextFlag={this.checkNextFlag}
                callBackConfirmPaymentVaild={this.confirmPaymentVaild}
              />
              <div
                className={`btn ${nextFlag === true ? "not-allow" : ""}`}
                onClick={this.clickToPayment}
              >
                {lang.payment}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Order;
